import {apiUrl} from '../common/Globals';
import {HTTP_GET} from '../common/HttpService';

const DashboardDataProvider = async (type, resource, params = {}) => {
  let url = apiUrl + '/dashboard';
  const query = [];
  if (params && params.filter) {
    const {startDate, endDate, service, paymentMethod} = params.filter;
    if (startDate) query.push(`startDate=${encodeURIComponent(startDate)}`);
    if (endDate) query.push(`endDate=${encodeURIComponent(endDate)}`);
    if (service) query.push(`service=${encodeURIComponent(service)}`);
    if (paymentMethod) query.push(`paymentMethod=${encodeURIComponent(paymentMethod)}`);
  }
  if (query.length > 0) {
    url += '?' + query.join('&');
  }
  let res = await HTTP_GET(url);
  return res;
};
export default DashboardDataProvider;
